import { useState } from 'react'
import { Modal } from './Modal'
import { apiFetch } from '../../lib/api'

interface Props {
  open: boolean
  onChanged: () => void
}

export function ChangePasswordModal({ open, onChanged }: Props) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [saving, setSaving] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)

    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }

    setSaving(true)
    try {
      await apiFetch('/api/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ new_password: password }),
      })
      onChanged()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to change password')
    } finally {
      setSaving(false)
    }
  }

  const inputCls = 'w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-gray-900 text-sm placeholder-gray-400 focus:outline-none focus:border-brand focus:ring-1 focus:ring-brand/20'

  return (
    <Modal open={open} onClose={() => {}} title="Change Password">
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-gray-600">
          You must set a new password before continuing.
        </p>

        <div>
          <label className="block text-xs uppercase tracking-wide text-gray-500 mb-1.5">
            New Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            placeholder="At least 8 characters"
            className={inputCls}
            autoFocus
          />
        </div>

        <div>
          <label className="block text-xs uppercase tracking-wide text-gray-500 mb-1.5">
            Confirm Password
          </label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            placeholder="Repeat password"
            className={inputCls}
          />
        </div>

        {error && (
          <p className="text-error text-sm">{error}</p>
        )}

        <button
          type="submit"
          disabled={saving}
          className="w-full bg-brand hover:bg-brand-dark text-white font-medium py-2 rounded-md transition-colors disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Set Password'}
        </button>
      </form>
    </Modal>
  )
}
